import { useLocation } from 'react-router-dom';

import { AppHamburgerButton } from '@frontend/App/AppHamburgerButton';
import { AppTopbarAddQuestion } from '@frontend/App/Topbar/App.Topbar.AddQuestion';
import { useIsEditor } from '@frontend/shared/hooks/shared.hook.useIsEditor';
import { useDirectoryTeam } from '@frontend/shared/hooks/useDirectory';

export function Topbar() {
  const team = useDirectoryTeam();
  const isEditor = useIsEditor();
  const { pathname } = useLocation();
  const isSearchPage = pathname.startsWith('/questions');
  const isSettingsPage = pathname.startsWith('/settings');
  const isDashboardPage = pathname.startsWith('/dashboard');

  const getPageTitle = () => {
    if (isSettingsPage) return 'Settings';
    if (isDashboardPage) return 'Dashboard';
    if (isSearchPage) {
      return isEditor ? 'Answer Bank' : team?.title;
    }
    return team?.title; // fallback for other pages
  };

  return (
    <div className="py-8 flex items-center">
      {/* Hamburger button on mobile only (editors/admins only) */}
      {isEditor && (
        <div className="lg:hidden mr-3">
          <AppHamburgerButton />
        </div>
      )}
      <h1
        className="mr-auto"
        style={{
          fontSize: '28px',
          lineHeight: '40px',
          fontWeight: 600,
          letterSpacing: '-0.01em',
          color: '#033426',
        }}
      >
        {getPageTitle()}
      </h1>
      {isSearchPage && <AppTopbarAddQuestion />}
    </div>
  );
}
